import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) { }

  getfaq() {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + environment.bearerToken);
    return this.http.get(`${this.baseUrl}v1/courses/faq/`, { headers });
  }
}
